/* eslint-disable react/prop-types */
import React, { useRef, useEffect, useState } from 'react';
import ModelToCompare from './ModelToCompare';
import useCarsData from '../../hooks/useCarsData';
import useRentTimeData from '../../hooks/useRentTimeData';
import ContactModal from './ContactModal';
import Slider from "react-slick";

const CompareModal = (props) => {

    const { getSelectedCar } = useCarsData();
    const { getSelectedUnitLabel, amount } = useRentTimeData();
    const [openContactModal, setOpenContactModal] = useState(false);
    const [secondCarSelected, setSecondCarSelected] = useState(null)
    const [thirdCarSelected, setthirdCarSelected] = useState(null)
    // referencias a los elementos que me interesa monitorear
    const containerRef = useRef(null);
    const closeRef = useRef(null);

    const settings =
    {
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: true,
                    centerPadding: '40px',
                }
            },
            {
                breakpoint: 10000, // a unrealistically big number to cover up greatest screen resolution
                settings: 'unslick'
            }
        ]
    };

    const print = () => {
        window.print();
    }

    // cerrar si el click fue afuera del contenedor o en la x
    const handleClose = (e) => {
        if (props.onClose && (!containerRef.current.contains(e.target) || closeRef.current.contains(e.target))) {
            props.onClose(false);
        }
    };

    const showContactModal = () => {
        return openContactModal ? <ContactModal onClose={handleClose} /> : null;
    }

    // habilitar y deshabilitar scroll
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = null;
        }
    }, [])

    return (
        <>
            <section className='compare-modal'>
                <div className='modal show print' onClick={handleClose}>
                    <div ref={containerRef} className='modal-box large'>
                        <div className='modal-header'>
                            <h3 className='title3'>
                                Compara y elige la mejor opción
                                {amount > 0 ? (
                                    <>
                                        ,{" "}
                                        <strong>
                                            Durante {amount}{" "}
                                            {amount === 1 &&
                                                getSelectedUnitLabel() === "Horas"
                                                ? "Hora"
                                                : amount === 1 &&
                                                    getSelectedUnitLabel() ===
                                                    "Días"
                                                    ? "Día"
                                                    : getSelectedUnitLabel()}
                                        </strong>
                                    </>
                                ) : null}
                            </h3>
                            <span
                                className='modal-close'
                                ref={closeRef}
                                onClick={handleClose}>
                                ✕
                            </span>
                        </div>
                        <div className='modal-content'>
                            <div className='modal-body'>
                                <div
                                    className='models-to-compare-grid'
                                    id='models-to-compare'>
                                    <Slider {...settings}>
                                        <ModelToCompare
                                            selectedCar={getSelectedCar()}
                                        />
                                        <ModelToCompare selectedCar={secondCarSelected} onChangeCar={setSecondCarSelected} />
                                        <ModelToCompare selectedCar={thirdCarSelected} onChangeCar={setthirdCarSelected} />
                                    </Slider>
                                </div>
                            </div>
                            <div className='modal-footer no-print'>
                                <div className='print-compare' onClick={print}>
                                    <img
                                        src={`${window._env_.STATIC_HOST}/static/kinto/img/cotizador/download_comparacion.svg`}
                                        className='print-icon'></img>
                                </div>
                                <a
                                    onClick={() => setOpenContactModal(true)}
                                    className='button button--navy'
                                    style={{ paddingBottom: "8px" }}
                                >
                                    Contactarme con un comercial
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showContactModal()}
        </>
    );

}

export default CompareModal;